<template>
  <v-card v-if="text" elevation="0" solid :color="light ? '' : 'grey lighten-3'" class="px-2 pt-2">
    <span
      v-if="text.length < minLength"
      style="font-size: 14px;"
      :style="light ? '' : 'color: grey;'"
      class="pre-wrap"
      ref=text-span
    >{{ text }}</span>
    <foldable v-else :height="height || 200" class="transition-demo" :class="light ? 'light-vue-foldable' : ''">
      <span ref=text-span class="pre-wrap" style="font-size: 14px" :style="light ? '' : 'color: grey;'">{{ text }}</span>
      <v-layout
        class="justify-center clickable pb-2"
        slot="view-more"
        slot-scope="{ toggle, collapsed }"
        style="height: 23px;"
        @click="toggle"
      >
        <v-icon>{{ collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
      </v-layout>
    </foldable>
  </v-card>
</template>

<script>
import VueFoldable from 'vue-foldable'
import 'vue-foldable/dist/vue-foldable.css'

import { urlify } from '@/lib/helpers/Text'

export default {
  props: {
    text: String,
    minLength: Number,
    height: Number,
    light: Boolean,
  },
  methods: {
    getInnerHTML () {
      let innerHTML = ''
      if (this.text) {
        innerHTML = urlify({
          string: this.text,
        })
      }
      const ref = this.$refs['text-span']
      if (ref) {
        ref.innerHTML = innerHTML
      }
    },
  },
  mounted () {
    this.getInnerHTML()
  },
  watch: {
    text () {
      this.getInnerHTML()
    },
  },
  components: {
    Foldable: VueFoldable,
  },
}
</script>

<style lang="scss">
.vue-foldable {
  .vue-foldable-container {
    overflow: hidden;
  }
  .vue-foldable-mask {
    position: absolute;
    bottom: 23px /* view-more's height */;
    height: 40px;
    left: 0;
    right: 0;
    background: transparent;
    pointer-events: none;
  }
}
.vue-foldable:not(.light-vue-foldable) .vue-foldable-mask.collapsed {
  background: linear-gradient(to bottom, rgba(#eeeeee, 0), #eeeeee);
}
</style>
